import { useEffect, useState } from 'react';
import promotionApi from '../services/promotionApi';

/**
 * Renvoie l'ensemble des id de menus actuellement couverts par une promotion active.
 * @param {number|null} restaurantId - limite la recherche a un restaurant (sinon toutes les promos actives)
 */
export default function usePromotedMenuIds(restaurantId = null) {
  const [promotedMenuIds, setPromotedMenuIds] = useState(new Set());

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const filters = restaurantId ? { restaurant_id: restaurantId, limit: 50 } : { limit: 50 };
        const promotions = await promotionApi.getPublicPromotions(filters);
        if (cancelled) return;
        const ids = new Set();
        (Array.isArray(promotions) ? promotions : []).forEach((promo) => {
          (promo.menu_ids || []).forEach((id) => ids.add(Number(id)));
        });
        setPromotedMenuIds(ids);
      } catch {
        if (!cancelled) setPromotedMenuIds(new Set());
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [restaurantId]);

  return promotedMenuIds;
}
